import React from 'react';

import { PaddingContainer, QuoteWithPhoto, WidthContainer } from '@components';
import { GroupedCaseStudy } from '@layouts/CaseStudies/types';
import { colors } from '@styles/core-styles/theme';

import * as styles from './Challenge.module.scss';

export const Challenge: React.FC<GroupedCaseStudy['challenge']> = ({
	description,
	image,
	quote,
	quoteAuthor,
	quoteImage,
}) => {
	return (
		<>
			<PaddingContainer className="gray-bg">
				<WidthContainer>
					<div className={styles.image}>
						<img src={image} alt="Challenge image" />
					</div>
					<div className="mt-4">
						<h2 className="font-size-small-title">The challenge</h2>
						<p className="font-size-sm line-height-sm limit-text preserve-white-space">
							{description}
						</p>
					</div>
				</WidthContainer>
			</PaddingContainer>
			<PaddingContainer className="white-bg">
				<WidthContainer>
					<QuoteWithPhoto
						className="white-bg"
						image={quoteImage}
						author={quoteAuthor}
						background={colors.grayLight}
						photoOnLeft
						containerStyles={{
							minHeight: 230,
						}}
					>
						<p className="font-size-sm">{quote}</p>
					</QuoteWithPhoto>
				</WidthContainer>
			</PaddingContainer>
		</>
	);
};
